import { render, staticRenderFns } from "./activity-xfans_drawing.vue?vue&type=template&id=b8948390&scoped=true&"
import script from "./activity-xfans_drawing.vue?vue&type=script&lang=js&"
export * from "./activity-xfans_drawing.vue?vue&type=script&lang=js&"
import style0 from "./activity-xfans_drawing.vue?vue&type=style&index=0&id=b8948390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8948390",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
